<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择工作中心"
      width="900px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        :filter.sync="filter"
        module="basic"
        url="workCenters">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号：">
            <el-input v-model.trim="filter.workCenterNo" placeholder="请输入编号" clearable/>
          </vm-search>
          <vm-search label="名称：">
            <el-input v-model.trim="filter.workCenterName" placeholder="请输入名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="workCenterNo" width="120" align="center" label="编号"/>
      <el-table-column prop="workCenterName" align="left" label="名称"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "WorkCenterSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {},
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
